import { DormitoryRoomStatuses } from "utils/constants";

export const ROOM_FREE_COLOR = "#B8D8BE";
export const ROOM_PARTIALLY_OCCUPIED_COLOR = "#E6D5A7";
export const ROOM_OCCUPIED_COLOR = "#B58986";
export const ROOM_UNAVAILABLE_COLOR = "#C8CDD2";

export const ROOM_STATES = {
  Free: "free",
  PartiallyOccupied: "partiallyOccupied",
  Occupied: "occupied",
  Unavailable: "unavailable",
};

export const ROOM_STATE_PRESENTATION = {
  [ROOM_STATES.Free]: { label: "Свободна", color: ROOM_FREE_COLOR },
  [ROOM_STATES.PartiallyOccupied]: { label: "Частично заета", color: ROOM_PARTIALLY_OCCUPIED_COLOR },
  [ROOM_STATES.Occupied]: { label: "Заета", color: ROOM_OCCUPIED_COLOR },
  [ROOM_STATES.Unavailable]: { label: "Недостъпна / За ремонт", color: ROOM_UNAVAILABLE_COLOR },
};


export const typeDescription = room => {
  if (!room) {
    return "";
  }
  return room.typeDescriptionBg || room.typeDescription || "";
};

export const conditionDescription = room => {
  if (!room) {
    return "";
  }
  return room.conditionDescriptionBg || room.conditionDescription || "";
};

export const isRoomUnusable = room => {
  const description = conditionDescription(room) || room?.conditionDescriptionEn || "";
  return room?.status === DormitoryRoomStatuses.Inactive
    || (typeof description === "string"
      && ["за ремонт", "under repair", "негодна за ползване", "unusable"]
        .includes(description.trim().toLowerCase()));
};

const committedBeds = room => (room?.occupiedBeds ?? 0) + (room?.allocatedBeds ?? 0);

export const splitCorridorRows = rooms => {
  const sorted = [...(rooms || [])].sort((a, b) => a.roomNumber - b.roomNumber || a.id - b.id);
  return {
    top: sorted.filter(room => room.roomNumber % 2 === 1),
    bottom: sorted.filter(room => room.roomNumber % 2 === 0),
  };
};

export const occupancyRatio = room => {
  if (!room?.capacity) {
    return 0;
  }
  return Math.min(1, Math.max(0, committedBeds(room) / room.capacity));
};

export const roomState = room => {
  if (room?.isUnusable) {
    return ROOM_STATES.Unavailable;
  }
  if (!committedBeds(room)) {
    return ROOM_STATES.Free;
  }
  if (room.capacity > 0 && committedBeds(room) >= room.capacity) {
    return ROOM_STATES.Occupied;
  }
  return ROOM_STATES.PartiallyOccupied;
};

export const normalizeMapRoom = room => {
  const capacity = room.capacity ?? 0;
  const occupiedBeds = room.occupiedBeds ?? 0;
  const allocatedBeds = room.allocatedBeds ?? 0;
  const unusable = isRoomUnusable(room);
  return {
    ...room,
    capacity,
    occupiedBeds,
    allocatedBeds,
    freeBeds: unusable ? 0 : Math.max(0, capacity - occupiedBeds - allocatedBeds),
    isUnusable: unusable,
    state: roomState({ ...room, capacity, occupiedBeds, allocatedBeds, isUnusable: unusable }),
  };
};
